import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div>
              <div className="text-2xl font-bold italic text-blue-600" style={{ fontFamily: 'Arial, sans-serif' }}>
                InteCare
              </div>
              <div className="text-xs text-gray-600 italic -mt-1">with Integrity and Care</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              About Us
            </Link>
            
            {/* Services Dropdown */}
            <div className="relative group">
              <button className="text-gray-700 hover:text-blue-600 transition-colors font-medium flex items-center">
                Services
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <Link to="/services/ambulatory" className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors">
                  Ambulatory Transport
                </Link>
                <Link to="/services/wheelchair" className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors">
                  Wheelchair Transport
                </Link>
                <Link to="/services/gurney" className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors">
                  Gurney Transport
                </Link>
                <Link to="/services/hospital-discharge" className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors">
                  Hospital Discharge
                </Link>
              </div>
            </div>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Contact
            </Link>
          </nav>

          {/* Phone */}
          <div className="hidden lg:flex items-center">
            <a 
              href="tel:+17147987318" 
              className="flex items-center text-blue-600 hover:text-blue-700 font-semibold"
            >
              <i className="ri-phone-line mr-2"></i>
              (714) 798-7318
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-blue-600"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-2 space-y-2">
              <Link 
                to="/" 
                className="block py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="block py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About Us
              </Link>
              <div>
                <button
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                  className="w-full flex items-center justify-between py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium"
                >
                  Services
                  <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isServicesOpen && (
                  <div className="bg-gray-50 rounded-lg mt-2">
                    <Link 
                      to="/services/ambulatory" 
                      className="block px-6 py-3 text-gray-600 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Ambulatory Transport
                    </Link>
                    <Link 
                      to="/services/wheelchair" 
                      className="block px-6 py-3 text-gray-600 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Wheelchair Transport
                    </Link>
                    <Link 
                      to="/services/gurney" 
                      className="block px-6 py-3 text-gray-600 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Gurney Transport
                    </Link>
                    <Link 
                      to="/services/hospital-discharge" 
                      className="block px-6 py-3 text-gray-600 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Hospital Discharge
                    </Link>
                  </div>
                )}
              </div>
              <Link 
                to="/contact" 
                className="block py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <div className="pt-4 border-t">
                <a 
                  href="tel:+17147987318" 
                  className="flex items-center text-blue-600 hover:text-blue-700 font-semibold"
                >
                  <i className="ri-phone-line mr-2"></i>
                  (714) 798-7318
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}